import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const PaymentProviderLogotype = styled.img`
  height: ${layout.measurements.spacingNormal};
`;

export const PaymentProviderMoreLabel = styled(CaptionText)``;
